/**
 * Root Sagas
 */
import {all} from 'redux-saga/effects';
import appSettingsSagas from './AppSettings.ts';
import authSagas from './Auth';
import dataProviderSagas from './DataProvider';
import realtimeSagas from './Realtime';

export default function* rootSaga() {
    yield all([
        realtimeSagas(),
        authSagas(),
        dataProviderSagas(),
        appSettingsSagas(),
    ]);
}
